import { Box } from '@mui/material'
import { NormalText } from '../../shared/styles'
import { getCoinsByNetwork } from './wallet.utils'
import { useTheme } from '@emotion/react'

export const Coins = ({ network }) => {
  const { palette } = useTheme()
  const coinsByNetwork = getCoinsByNetwork(network)

  return (
    <Box display="flex" flexDirection="column" gap={'8px'}>
      <NormalText size={12}>
        You can use the following coins on this network
      </NormalText>
      <Box display="flex" gap={'8px'}>
        {coinsByNetwork.map((coin) => (
          <Box
            display="flex"
            alignItems="center"
            gap={'8px'}
            key={coin.value}
            borderRadius={'8px'}
            padding={'4px 8px'}
            backgroundColor={palette.grey[3]}
          >
            <img
              src={coin.icon}
              alt={coin.value}
              width={24}
              height={24}
              style={{ borderRadius: '50%' }}
            />
            <NormalText size={12} color={palette.neutral.black}>
              {coin.label}
            </NormalText>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
